import { MNSproCloudApi } from '..';

export class SupportService {
  static async getHybridSettings(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.HybridSyncSettingsApiFactory(config);

    const result = await api.getHybridSyncSettings(organizationId, {
      validateStatus: (status: number) => status < 300 || status === 404,
    });

    return result.status === 404 ? null : result.data;
  }

  static async updateHybridSettings(
    authToken: string,
    organizationId: string,
    settings: {
      isSyncEnabled: boolean;
      customErrorMessage?: string;
      synchronizedPeriodId?: string;
    },
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.HybridSyncSettingsApiFactory(config);

    const { isSyncEnabled, customErrorMessage, synchronizedPeriodId } =
      settings;

    const response = await api.updateHybridSyncSettings(organizationId, {
      syncActive: isSyncEnabled,
      activeHybridSyncPeriodIdentifierId: synchronizedPeriodId,
      customErrorMessage,
    });

    return response.data;
  }

  static repairOwnerships = async (
    authToken: string,
    organizationId: string,
  ): Promise<string> => {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.OrganizationsApiFactory(config);

    const response = await api.repairOwnerships(organizationId);

    return response.data;
  };
}
